import { render, staticRenderFns } from "./ZedlockerBalance.vue?vue&type=template&id=1dd15c40&scoped=true"
import script from "./ZedlockerBalance.vue?vue&type=script&lang=js"
export * from "./ZedlockerBalance.vue?vue&type=script&lang=js"
import style0 from "./ZedlockerBalance.vue?vue&type=style&index=0&id=1dd15c40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd15c40",
  null
  
)

export default component.exports